/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/8
 */
import React, {Component} from 'react';
import classNames from 'classname';
import Bread from './bread';
import Header from './header';
import Footer from './footer';
import Monitor from '../../svgs/monitor';
import Quality from '../../svgs/quality';
import Recover from '../../svgs/recover';
import BackupData from '../../svgs/backupData';
import CancelPassword from '../../svgs/cancelPassword';
import QuitAccount from '../../svgs/quitAccount';

class Step extends Component {
  selectingFooter = [{
    icon: <Monitor />,
    title: '全程视频监控',
    detail: ['从收到商品到质检结束，每个步骤都全程视频', '监控，检测放心可保障。']
  }, {
    icon: <Quality/>,
    title: '专业质检不忽悠',
    detail: ['专业的工程师，按统一标准流程检验，拒绝主', '观评判，各项指标可信赖。']
  }, {
    icon: <Recover/>,
    title: '回收不压价',
    detail: ['回收企业直接回收，避免恶意压价。']
  }];
  finishFooter = [{
    icon: <BackupData/>,
    title: '备份好个人数据',
    detail: ['备份好数据并恢复到出厂设置']
  }, {
    icon: <CancelPassword/>,
    title: '取消密码',
    detail: ['请将所设置的密码取消', '以便我们的检测人员及时进行功能检测']
  }, {
    icon: <QuitAccount/>,
    title: '退出账号',
    detail: ['苹果手机iOS7以上请退出iCloud账号', '魅族请退出Flyme账户']
  }];
  render () {
    const { step, queryKey } = this.props;
    let footer = null;
    if (step !== 0) {
      footer = <Footer items={step < 3 ? this.selectingFooter : this.finishFooter} />;
    }

    return <div className={classNames('mzcontainer', `mcycle-step${step}`)}>
      <Bread action={step} queryKey={queryKey} />
      <Header action={step} />
      <div className="mcycle-step-container">
        {this.props.children}
      </div>
      { footer }
    </div>
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/components/step/index.js